import React from 'react';
type FormFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: string;
  placeholder?: string;
  multiline?: boolean;
  autoComplete?: string;
};
export function FormField({
  id,
  label,
  value,
  onChange,
  error,
  type = 'text',
  placeholder,
  multiline,
  autoComplete
}: FormFieldProps) {
  const base = `w-full rounded-sm border bg-white px-4 text-[15px] text-charcoal placeholder:text-steel/60 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gold/40 ${error ? 'border-red-600 focus:border-red-600' : 'border-hairline focus:border-navy'}`;
  return <div data-id="element-81" data-mp="2t53qbiz1ba51">
      <label htmlFor={id} className="block text-sm font-medium text-navy" data-id="element-82" data-mp="2p1ntalj1z7rt">
        {label}
      </label>
      {multiline ? <textarea id={id} rows={5} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} className={`${base} mt-2 resize-none py-3`} data-id="element-83" data-mp="330nko0xya0ro" /> : <input id={id} type={type} value={value} placeholder={placeholder} autoComplete={autoComplete} onChange={e => onChange(e.target.value)} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} className={`${base} mt-2 h-12`} data-id="element-84" data-mp="1eddpy52ye22j" />}
      {error && <p id={`${id}-error`} className="mt-2 text-sm text-red-700" data-id="element-85" data-mp="1xaonnl8xsnfv">
          {error}
        </p>}
    </div>;
}